import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";


export default function DashboardOrders() {

  const { status } = useParams();
const [delivering, setDelivering] = useState(null);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    loadOrders();
  }, [status]);


  const loadOrders = async () => {

    try {

      const res = await axiosInstance.get(
        `/dashboard/orders/?status=${status}`
      );

      setOrders(res.data);

    } catch {

      alert("Failed to load orders ❌");

    } finally {

      setLoading(false);

    }
  };
const markDelivered = async (orderId) => {

  if (!window.confirm("Mark this order as delivered?")) return;

  try {

    setDelivering(orderId); // disable button

    await axiosInstance.post(
      "/orders/mark-pickup-delivered/",
      { order_id: orderId }
    );

    alert("✅ Order delivered successfully!");

    await loadOrders(); // refresh

  } catch (err) {

    console.error(err);
    alert("❌ Failed to update order");

  } finally {

    setDelivering(null); // enable again

  }
};



  if (loading) {
    return <p>Loading...</p>;
  }

console.log(orders);

  return (

    <div style={container}>

      <h1>📋 {status.toUpperCase()} Orders</h1>


      {orders.length === 0 && (
        <p>No orders found</p>
      )}


 {orders.map(o => (

  <div key={o.id} style={card}>

    <h3>Order #{o.id}</h3>

    <p><b>User:</b> {o.user}</p>
    <p><b>Phone:</b> {o.phone}</p>
    <p><b>Amount:</b> ₹{o.amount}</p>
    <p><b>Status:</b> {o.status}</p>


    {/* ✅ PICKUP DELIVERED BUTTON */}
 {o.status === "approved_store_pickup" && (

  <button
    disabled={delivering === o.id}
    onClick={() => markDelivered(o.id)}
    style={{
      background:
        delivering === o.id ? "#9ca3af" : "#2563eb",

      color: "white",
      padding: "7px 14px",
      border: "none",
      borderRadius: 6,
      cursor: delivering === o.id ? "not-allowed" : "pointer",
      marginTop: 10,
      fontWeight: "bold"
    }}
  >
    {delivering === o.id
      ? "⏳ Processing..."
      : "📦 Mark Delivered"}
  </button>

)}

{o.status === "delivered" && (
  <span style={{ color: "green", fontWeight: "bold" }}>
    ✅ Delivered (History)
  </span>
)}

{o.status === "approved_store_pickup" && (
  <span style={{ color: "orange", fontWeight: "bold" }}>
    🏬 Waiting Pickup
  </span>
)}



  </div>

))}


    </div>
  );
}



/* -------- STYLES -------- */

const container = {
  maxWidth: 900,
  margin: "auto",
  padding: 25
};


const card = {
  background: "#fff",
  padding: 15,
  marginBottom: 12,
  borderRadius: 8,
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
};
